import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './StickyCTA.module.scss';

const StickyCTAButtonsContainer = ({ primaryButton, secondaryButton }) => {
  const btnSizeClass = cx('text-capitalize', {
    'w-100': !(primaryButton && secondaryButton),
    [styles['half']]: primaryButton && secondaryButton
  });
  return (
    <div className="w-100 d-flex justify-content-between">
      {secondaryButton && <div className={btnSizeClass}>{secondaryButton}</div>}
      {primaryButton && <div className={btnSizeClass}>{primaryButton}</div>}
    </div>
  );
};

StickyCTAButtonsContainer.propTypes = {
  primaryButton: PropTypes.element,
  secondaryButton: PropTypes.element
};

export default StickyCTAButtonsContainer;
